jQuery( document ).ready(
	function ($) {
		if ($( "body" ).hasClass( "single-jh_events" )) {
			// Banner Image - Background 
			var window_width 	  = $( window ).width(); 
			// Banner Image vars
			var banner_url  	  = $("#event-banner-params").data("banner-img-url");
			var sharp_edge_banner = $("#event-banner-params").data("sharp-edged");
			var bg_wrapper_height = "40rem";
			var bg_percent 		  = "90%";
			
			if ( window_width <= 1200 && window_width > 886 ) { bg_wrapper_height = '41rem'; }
			if ( window_width <= 885 && window_width > 576 ) { bg_wrapper_height = '27rem';  bg_percent = '120% '; } 
			if ( window_width <= 575 ) { bg_wrapper_height = ' 21rem'; bg_percent = '140% '; } 

			// Check if sharp Edged stat for Banner Image
			if ( sharp_edge_banner ) { 
				$( '.hfeed' ).addClass( 'hfeed-class' );
				$( '.hfeed-class' ).attr( 'style', "background:" + banner_url + 
										  "background-size: " + bg_percent + bg_wrapper_height + " !important"); 
				$( '.bg-gradient .banner-bg' ).attr( 'style', "height: 18rem;" );
			} else {
				$( '.bg-gradient' ).addClass( 'banner-class' );
				$( '.bg-gradient .banner-bg' ).attr( 'style', "background:" + banner_url + 
												 "background-size: " + bg_percent + bg_wrapper_height + " !important; height: 23rem;" );  
			}

			//---Menu Functions
			$( ".jh-sticky-nav-wrapper ul li" )
			.first()
			.addClass( "active" );

			$( ".jh-sticky-nav-wrapper ul li" ).click(
				function () {
					if ( ! $( this ).hasClass( "active" )) {
						$( ".jh-sticky-nav-wrapper ul li" ).removeClass( "active" );
						$( this ).addClass( "active" );
					}
				}
			);

			//Adds register button to navigation list
			// $(
			//     ".eventPreContentContainer .eventNavigationContainer ul.list-group-horizontal"
			// ).append(
			//     '<li class="sticky-nav-item list-group-item register"><a href="#register">Register</a></li>'
			// );

			//Shifts every third speaker info container into a grouping with the container after it
			var shiftInfo = function () {
				var infoTotal = $( ".speakerContainer .speakerInfo" ).length;
				var round     = Math.ceil( infoTotal );
				for (i = 0; i < round; i += 2) {
					var plusOne   = i + 1;
					var movedInfo = $( ".speakerContainer .speakerInfo:eq(" + i + ")" );
					$( '.speakerContainer .speakerInfo:eq(' + plusOne + ')' ).before( movedInfo );
					$( movedInfo ).find( '.speakerInfoInner' ).addClass( 'rightBorder' );
					$( '.speakerContainer .speakerInfo:eq(' + plusOne + ')' ).find( '.speakerInfoInner' ).addClass( 'leftBorder' );
				}
			};

			//Shifts every third speaker info container under it's matching speaker container
			var shiftInfoNormal = function () {
				var infoTotal = $( ".speakerContainer .speakerInfo" ).length;
				var round     = Math.ceil( infoTotal );
				for (i = 0; i < round; i += 2) {
					var plusOne     = i + 1;
					var movedInfo   = $( ".speakerContainer .speakerInfo:eq(" + i + ")" );
					var movedInfoId = $( ".speakerContainer .speakerInfo:eq(" + i + ")" ).attr( 'id' );
					$( '.speakerContainer .speakerSnapshotContainer' ).each(
						function () {
							if ($( this ).hasClass( movedInfoId )) {
								$( this ).after( movedInfo )
							}
						}
					);
				}
			};

			if ( window_width > 767) {
				shiftInfo()
			}

			$( window ).resize(
				function () {
					if ( window_width < 767) {
						shiftInfoNormal()
					} else {
						shiftInfo()
					}
				}
			);

			//Collapse toggling functionality
			$( '.speakerContainer .speakerSnapshotContainer .collapseButton a' ).click(
				function () {
					var parentContainer = $( this ).closest( '.speakerSnapshot' );
					var thisCollapse    = $( this ).attr( 'aria-controls' );

					$( '.speakerContainer .speakerSnapshotContainer .speakerSnapshot' ).each(
						function () {
							$( this ).removeClass( 'active' );
						}
					)

					$( parentContainer ).toggleClass( 'active' );

					if ($( '#' + thisCollapse ).hasClass( 'show' )) {
						$( '#' + thisCollapse ).collapse( 'toggle' );
						$( '.speakerSnapshot.active' ).removeClass( 'active' );
					} else {
						$( '.speakerInfo.collapse.show' ).collapse( 'hide' );
						$( '#' + thisCollapse ).collapse( 'show' );
					}

				}
			);

			var markerTotal = passedData.length;
			var markerData  = passedData;
			var locations   = [];
			var centerLat   = passedData[0][1];
			var centerLon   = passedData[0][2];
			for (i = 0; i <= markerTotal - 1; i ++) {
				locations.push( markerData[i] );
			}
			  var map;
			  var markers = [];

			function init()
			  {
				map = new google.maps.Map(
					document.getElementById( 'locations-map-event' ),
					{
						zoom: 15,
						center: new google.maps.LatLng( centerLat, centerLon ),
						mapTypeId: google.maps.MapTypeId.ROADMAP
					}
				);

				var num_markers = locations.length;
				for (var i = 0; i < num_markers; i++) {
					markers[i] = new google.maps.Marker(
						{
							position: {lat:locations[i][1], lng:locations[i][2]},
							map: map,
							html: locations[i][0],
							id: i,
						}
					);

					google.maps.event.addListener(
						markers[i],
						'click',
						function(){
							var infowindow = new google.maps.InfoWindow(
								{
									id: this.id,
									content:this.html,
									position:this.getPosition()
								}
							);
							google.maps.event.addListenerOnce(
								infowindow,
								'closeclick',
								function(){
									markers[this.id].setVisible( true );
								}
							);
							this.setVisible( false );
							infowindow.open( map );
						}
					);
				}

			}

			  google.maps.event.addDomListener( window, 'load', init );

			if ($( '.datesContainer .end' ).is( ':empty' )) {
				$( '.datesContainer .through' ).remove();
			} 
		}
	}
);
